import { Theme } from '@mirai/ui';

const DEFAULT_IMAGE_HEIGHT = 208;

export const getCardImageHeight = () => {
  const { imageHeight = DEFAULT_IMAGE_HEIGHT } = Theme.get('--mirai-card-') || {};

  return imageHeight;
};
